import React from 'react';
import PromotionCodeCapture from '../components/PromotionCodeCapture';
import Seo from '../components/Seo';
import { PAGE_META } from '../seo/pageMeta';
import Hero from '../components/Hero';
import StartHere from '../components/home/StartHere';
import ExamSection from '../components/ExamSection';
import PracticeFlow from '../components/home/PracticeFlow';
import MockExamTeaser from '../components/home/MockExamTeaser';
import ExamTipsTeaser from '../components/home/ExamTipsTeaser';
import WhatYouGet from '../components/home/WhatYouGet';
import PricingTeaser from '../components/home/PricingTeaser';
import BlogTeaser from '../components/home/BlogTeaser';
import AboutUs from '../components/AboutUs';
import FAQSection from '../components/FAQSection';
import ContactSection from '../components/ContactSection';
import Disclaimer from '../components/Disclaimer';
import Footer from '../components/Footer';

/**
 * The homepage, previously an inline fragment in App.js's "/" route.
 *
 * The order asks the visitor for exactly ONE decision — StartHere — and then
 * gets out of the way. Everything after it is reference: what the test is, what
 * rehearsing it looks like, what is included, what it costs.
 *
 * The earlier order had five card grids in a row (~20 parallel options, none
 * marked as the visitor's), which is what made the page tiring. Two of them were
 * near-duplicates: "How it works" walked through guest → free → paid immediately
 * before the pricing table explained the same three tiers, so it is gone and the
 * pricing section carries that story alone. "Everything that's included" moved
 * below the exam sections — as the second thing on the page a grid of six asked
 * "which is me?" before anyone could answer; read later it answers "what else is
 * in here?", which is a question people arrive at by themselves.
 *
 * Bands alternate white/whitesmoke so sections read as distinct — the old page
 * put whitesmoke on the hero, the body and ExamSection alike and blurred into
 * one wash.
 */
const Home = () => (
  <>
    <PromotionCodeCapture allowedPaths={['/']} />
    <Seo {...PAGE_META.home} />
    <Hero />
    {/* The band alternation lives here and nowhere else. Each section used to
        pick its own tone, and since no component can see what the one above it
        chose, the page ended up running three tinted sections together and then
        two plain ones — so the bands never read as divisions at all. Listed in
        one place, the rhythm is obvious and stays correct when sections move. */}
    <StartHere tone="tint" />
    <ExamSection tone="plain" />
    <PracticeFlow tone="tint" />
    <MockExamTeaser tone="plain" />
    <ExamTipsTeaser tone="tint" />
    <WhatYouGet tone="plain" />
    <PricingTeaser tone="tint" />
    <BlogTeaser tone="plain" />
    <AboutUs tone="tint" />
    <FAQSection tone="plain" />
    <ContactSection tone="tint" />
    <Disclaimer />
    <Footer showSitemap />
  </>
);

export default Home;
